<template>
  <eg-modal
    id="trial-welcome-modal"
    size="content"
    centered
    :closable="true"
    :hide-title="true"
    @close="startTrial"
  >
    <eg-button
      type="ordinary"
      size="small"
      class="eg-modal__close"
      icon="close"
      icon-size="small"
      icon-color="var(--color-icon-neutral-neutral)"
      @click="startTrial"
    />
    <div class="trial-welcome-modal">
      <div class="trial-welcome-content">
        <h1 class="trial-welcome-title">
          {{ $t("dashboard.trial.welcomeTitle") }}
        </h1>
        <p class="trial-welcome-subtitle paragraph-m">
          {{ $t("dashboard.trial.welcomeSubtitle") }}
        </p>

        <ul class="trial-features-list">
          <li
            v-for="(value, index) in trialStartFeaturesList"
            :key="index"
            class="trial-feature-item caption-s"
          >
            <eg-icon
              icon="check-circle"
              size="medium"
              color="var(--color-text-neutral-disabled)"
            />
            <span>{{ value }}</span>
          </li>
        </ul>
        <div class="actions d-flex align-items-center flex-gap-1">
          <eg-button
            type="primary"
            icon="stars"
            icon-size="medium"
            size="medium"
            class="trial-start-button"
            @click="startTrial"
          >
            {{ $t("dashboard.trial.startFreeTrial") }}
          </eg-button>

          <p class="trial-no-card-text caption-s">
            {{ $t("dashboard.trial.noCardRequired") }}
          </p>
        </div>
      </div>

      <div class="trial-welcome-image">
        <div class="image-placeholder">
          <img src="@/assets/trial/welcome-preview.jpg" alt="" />
        </div>
      </div>
    </div>
  </eg-modal>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "TrialWelcomeModal",
  computed: {
    trialStartFeaturesList() {
      return this.$store.getters.trialStartFeaturesList;
    },
  },
  methods: {
    startTrial() {
      this.$emit("onSuccess");
      this.$egModal.hide("trial-welcome-modal");
    },
  },
});
</script>

<style scoped lang="scss">
#trial-welcome-modal {
  .eg-modal__close {
    position: absolute;
    top: 8px;
    right: 14px;
  }
}
.trial-welcome-modal {
  display: grid;
  grid-template-columns: 380px 420px;
  gap: 1.5rem;
  min-height: 500px;
  padding-top: 16px;
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 32px;
    padding: 32px;
  }
}

.trial-welcome-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.5rem;
  padding-right: 0;

  .trial-welcome-title {
    font-size: var(--typography-font-size-fs-750);
    font-weight: var(--typography-font-weight-fw-800, 800);
    margin: 58px 0 0.5rem 0;
  }

  .trial-welcome-subtitle {
    color: var(--color-text-neutral-secondary);
    font-weight: var(--typography-font-weight-fw-400, 400);
    margin: 0 0 32px 0;
    text-rendering: geometricPrecision;
  }

  .trial-features-list {
    list-style: none;
    padding: 0;
    margin: 0 0 40px 0;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .trial-feature-item {
      display: flex;
      align-items: center;
      gap: 12px;
      i {
        color: var(--color-text-neutral-disabled);
      }
    }
  }

  .trial-no-card-text {
    margin: 0;
    color: var(--color-text-neutral-secondary);
  }
}

.trial-welcome-image {
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .image-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 24px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
